import React, { useEffect, useState } from "react";
import {
  getCampaignLeadByIdApi,
  getCampaignLeadDispositionApi,
} from "../../store/saga/requests/campaignRequests";
import { ICampaignLeadType } from "../../types/campaignTypes";
import { useAppSelector } from "../../store/hooks";
import { ErrorMessage, Field, Form, Formik } from "formik";

export default function CampaignLeadDetailTab() {
  const data = useAppSelector((state) => state?.campaign.lead);
  //   const [data, setData] = useState<ICampaignLeadType>();
  //   useEffect(() => {
  //     getData();
  //   }, [id]);
  //   const getData = async () => {
  //     await getCampaignLeadByIdApi(Number(id)).then((response) => {
  //       setData(response.data);
  //     });
  //     await getCampaignLeadDispositionApi({ take: 10, skip: 0 }, Number(id));
  //   };
  const initialValues = data;
  return (
    <div>
      <div className="w-full bg-primary p-2">
        <span className="text-white font-semibold">
          {data?.name} - {data?.phoneNumber}
        </span>
      </div>

      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        // validationSchema={validationSchema}
        onSubmit={(values, actions) => {}}
      >
        {(formikProps) => (
          <>
            {/* {console.log(formikProps)}{" "} */}
            <Form className="">
              <div className="mt-3">
                <div className=" grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 gap-4">
                  <div className="">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Role
                    </label>
                    <Field
                      disabled={true}
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="role"
                      name="role"
                      type="text"
                    />
                  </div>
                  <div className="">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Lead ID
                    </label>
                    <Field
                      disabled={true}
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="leadId"
                      name="leadId"
                      type="number"
                    />
                  </div>
                  <div className="">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Lead Stage
                    </label>
                    <Field
                      disabled={true}
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="status"
                      name="status"
                      type="text"
                    />
                  </div>
                  <div className="">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Call Type
                    </label>
                    <Field
                      disabled={true}
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="leadType"
                      name="leadType"
                      type="text"
                    />
                  </div>
                  <div className="">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Gender
                    </label>
                    <Field
                      disabled={true}
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="gender"
                      name="gender"
                      type="text"
                    />
                  </div>
                  <div className="">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Email
                    </label>
                    <Field
                      disabled={true}
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="email"
                      name="email"
                      type="text"
                    />
                  </div>
                  <div className="">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Country
                    </label>
                    <Field
                      disabled={true}
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="country.name"
                      name="country.name"
                      type="text"
                    />
                  </div>
                  <div className="">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Date of Birth
                    </label>
                    <Field
                      disabled={true}
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="dob"
                      name="dob"
                      type="text"
                    />
                  </div>
                  <div className="">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Aadhaar No
                    </label>
                    <Field
                      disabled={true}
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id=""
                      name=""
                      type="text"
                    />
                  </div>
                  <div className="">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Address
                    </label>
                    <Field
                      disabled={true}
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="address"
                      name="address"
                      type="text"
                    />
                  </div>
                  <div className="">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      state
                    </label>
                    <Field
                      disabled={true}
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="state"
                      name="state"
                      type="text"
                    />
                  </div>
                  <div className="">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      pincode
                    </label>
                    <Field
                      disabled={true}
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="pincode"
                      name="pincode"
                      type="text"
                    />
                  </div>
                  {/* <div className="">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Bank Acc no
                    </label>
                    <Field
                      disabled={true}
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="email"
                      name="email"
                      type="text"
                    />
                  </div>
                  <div className="">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      IFSC Code
                    </label>
                    <Field
                      disabled={true}
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="email"
                      name="email"
                      type="text"
                    />
                  </div> */}
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}
